import {Action, createReducer, on} from "@ngrx/store";

export interface State {

}

export const initialState: State = {

};

const assistantsReducer = createReducer(
  initialState,

)

export const reducer = (state: State | undefined, action: Action): State =>
  assistantsReducer(state, action);



